module.exports = __webpack_public_path__ + "0a9eed886e9a55db95982d9c9bbb92a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/score-4.svg
// module id = 164
// module chunks = 0